module.exports = __webpack_public_path__ + "static/mountains-e354aa94048fe5cef3ccd6efc39deffb.png";